// extracted by mini-css-extract-plugin
module.exports = {"Main":"Layout_Main__3C81A"};